export default __webpack_public_path__ + "static/media/kako_funkcionisu_4.ccae818b.png";